import { useState } from 'react';
import { UploadChangeParam } from 'antd/es/upload';
import { Input, Modal, Upload } from 'antd';
import { handleFileChange } from '../../../Helpers/uploadHelper';
import { ICompany } from '../../../Types/Interfaces/ICompany';
import { companyStore } from '../../../GlobalStore';
import { CreateCompanyModalProp } from './types';
import { SWCropImageModal } from '../';
import styles from './index.module.scss';

const SWCreateCompanyModal = ({
  onOk,
  visible,
  onCancel
}: CreateCompanyModalProp) => {
  const [createLoading, setCreateLoading] = useState<boolean>(false);
  const [uploadedImgUrl, setUploadedImgUrl] = useState<string>();
  const [inputs, setInputs] = useState<ICompany>({ name: "", logo: ""} as ICompany);
  const [visibleCropModal, setVisibleCropModal] = useState<boolean>(false);

  const handleChange = (info: UploadChangeParam) => {
    if (typeof inputs === 'undefined') return;
    handleFileChange(
      info,
      (url) => {
        setUploadedImgUrl(url);
        setInputs({ ...inputs, logo: url });
        setVisibleCropModal(true);
      },
      () => {
        setUploadedImgUrl(undefined);
        setInputs({ ...inputs, logo: '' });
      }
    );
  };

  const createCompany = () => {
    if (inputs) {
      setCreateLoading(true);
      companyStore.createCompany(
        {
          logo: inputs?.logo,
          name: inputs?.name
        },
        {
          onSuccess: () => {
            resetModal();
            onOk();
          },
          onFinally: () => setCreateLoading(false)
        }
      );
    }
  };

  const resetModal = () => {
    setUploadedImgUrl(undefined);
    setInputs({
      id: '-1',
      name: '',
      logo: ''
    });
    onCancel?.();
  };

  const handleCloseVisibleCropModal = (croppedImage: string | null) => {
    if(croppedImage) {
      setInputs({ ...inputs, logo: croppedImage });
      setUploadedImgUrl(croppedImage); 
    }
    setVisibleCropModal(false);
  }

  const handleCancelVisibleCropModal = () => {
    setVisibleCropModal(false);
  };

  return (
    <Modal
      title={'Şirket Ekle'}
      destroyOnClose
      okText={'Kaydet'}
      onOk={createCompany}
      okButtonProps={{
        loading: createLoading,
        disabled: !inputs?.name || !inputs.logo
      }}
      cancelButtonProps={{ disabled: createLoading }}
      onCancel={() => (createLoading ? null : resetModal())}
      open={visible}>
      <div className={styles.formItem}>
        <label htmlFor="companyName">Firma Adı</label>
        <Input
          value={inputs?.name}
          onChange={(e) =>
            setInputs({
              ...inputs,
              name: e?.currentTarget?.value
            } as ICompany)
          }
          id="companyName"
        />
      </div>
      <div className={styles.formItem}>
        <label>Firma Logo</label>
        <Upload
          maxCount={1}
          name="avatar"
          accept={'image/*,.svg'}
          className={styles.uploadBtn}
          onPreview={() => {
            setVisibleCropModal(true);
          }}
          fileList={[
            {
              uid: '1',
              name: 'currentLogo',
              url: uploadedImgUrl || ""
            }
          ]}
          listType="picture-card"
          onChange={handleChange}>
          <span>Upload</span>
        </Upload>
      </div>
      <SWCropImageModal 
        image={uploadedImgUrl || ""} 
        visible={visibleCropModal} 
        onClose={handleCloseVisibleCropModal}
        onCancel={handleCancelVisibleCropModal}
      />
    </Modal>
  );
};

export default SWCreateCompanyModal;
